<template>
	<div class="basis-page-cls">
        <section class="basis-cls_table">
            <div class="table">
				<table-pagination
                    pagination
                    :data="list"
                    :column="column"
                    :total="total"
                    :page.sync="listQuery.pageNum"
                    :limit.sync="listQuery.pageSize"
                    @pagination="getList" />
            </div>
        </section>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { EnumMixin } from "utils/mixins";
export default {
	props: ['item', 'customerId'],
	mixins: [EnumMixin],
	computed: {
        ...mapGetters([
			'userInfo'
		])
    },
	data() {
		return {
            column: [],
			listQuery: {
				pageSize: 10,
                pageNum: 1,
				order_by: "create_time desc",
				data: {
					tab_id: '',
					queryConditions: []
				}
            },
			total: 0,
			list: []
		}
    },
	created() {
		this.getTableHeaderList();
		this.getList();
	},
	methods: {
		getList() {
			this.listQuery.data.queryConditions = [];
			this.listQuery.data.tab_id = this.item?.tabId;
			for(const item of this.item?.queryConditions) {
				if(item.prop === 'custId') {
					item['value'] = this.customerId;
				} else {
					item['value'] = '';
				}
				this.listQuery.data.queryConditions.push({
					prop: item.prop,
					value: item.value
				});
			}
			console.log(this.listQuery)
			this.$api.apiPostTableList(this.listQuery).then(response => {
				if(response.errcode != 0) return;
				this.list = response.list;
				this.total = parseInt(response.total);
			});
		},
		getTableHeaderList() {
			this.$api.apiGetTableHeaderList({tabId: this.item.tabId}).then(response => {
				if(response.errcode != 0) return;
				this.column = response?.data?.column || [];
			});
		},
        filterSearch(query) {
			this.listQuery = Object.assign(this.listQuery, query);
		}
    }
}
</script>